/**
 * Check if any background values are set for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { BackgroundValues } from '../../types';

/**
 * Check if any background values are set for a specific breakpoint
 */
export const hasBackgroundValues = ( values: BackgroundValues ): boolean => {
	return !! (
		values.backgroundColor ||
		values.backgroundImage?.url ||
		values.backgroundGradient ||
		values.customGradient ||
		values.backgroundPattern ||
		values.backgroundOverlay?.enabled
	);
};
